var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -1590)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 1590)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1330 1626)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1313.164 1593.741)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.993 30.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.38,47.108H74.156a.958.958,0,1,1,0-1.915H80.38a.958.958,0,1,1,0,1.915Z",
    transform: "translate(-73.198 -45.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.479 5.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.449,13.4a.958.958,0,0,1-.958-.958V6.217a.958.958,0,0,1,1.915,0v6.225A.958.958,0,0,1,49.449,13.4Z",
    transform: "translate(-48.491 -5.259)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.93 19.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.464,31.49a.958.958,0,0,1-.351-1.85l5.5-2.163a.958.958,0,1,1,.7,1.783l-5.5,2.163A.956.956,0,0,1,72.464,31.49Z",
    transform: "translate(-71.506 -27.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.805 9.123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3,18.4a.958.958,0,0,1-.78-1.512l3.6-5.076a.958.958,0,0,1,1.562,1.108L65.083,18A.955.955,0,0,1,64.3,18.4Z",
    transform: "translate(-63.344 -11.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.813,54.169c-2.576-2.9,8.17-5.246,8.17-16.48,0-15.048-10.956-15.233-13.259-15.233S23.465,23.791,23.465,37.689c0,11.234,10.745,13.583,8.17,16.48C28.24,57.987,16.5,53.18,16.5,68.006H56.946C56.947,53.18,45.208,57.987,41.813,54.169ZM36.707,41.525c-1.31-.721-4.857-3.08-5.062-6.15-.239-3.587,4.369-3.107,5.062-.45.693-2.658,5.3-3.137,5.062.45C41.564,38.445,38.016,40.8,36.707,41.525Z",
    transform: "translate(-2.108 -6.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.836 30.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.018,47.108H11.794a.958.958,0,0,1,0-1.915h6.224a.958.958,0,0,1,0,1.915Z",
    transform: "translate(-10.836 -45.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.621 19.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.138,31.49a.955.955,0,0,1-.35-.067l-5.5-2.163a.958.958,0,1,1,.7-1.783l5.5,2.163a.958.958,0,0,1-.351,1.849Z",
    transform: "translate(-13.679 -27.41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.529 8.494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.428,17.4a.956.956,0,0,1-.782-.4l-3.6-5.076A.957.957,0,0,1,29.6,10.815l3.6,5.076a.957.957,0,0,1-.227,1.335A.947.947,0,0,1,32.428,17.4Z",
    transform: "translate(-27.866 -10.411)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon2);
export default __webpack_public_path__ + "static/media/prowess-icon2.381d78e3183297e3199ca4a6f49fff28.svg";
export { ForwardRef as ReactComponent };